import { defineComponent as _defineComponent } from 'vue'
import { IEpisode } from '~/types/series';
import ProjectEpisode from './ProjectEpisode.vue';
import { useStore } from '~/store/composable';
import { computed, useContext, useRouter } from '@nuxtjs/composition-api';
import { TPromptToLoginDispatch } from '~/store/types';
import { RZR_EPISODE_1_SLUG } from '~/store/projects/types';
import { IProject } from '~/types/project';
import ProjectMysteryBoxUpsell from './ProjectMysteryBoxUpsell.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectEpisodesTab',
  props: {
    episodes: null,
    projectSlug: null,
    project: null
  },
  setup(__props: any) {

const props = __props as {
  episodes: IEpisode[];
  projectSlug: string;
  project: IProject;
};



const { state, dispatch } = useStore();
const router = useRouter();

const { $vuetify } = useContext();

const userId = computed(() => state.profile?.user?.id);

const watchableEpisodes = computed(() =>
  props.episodes.filter((episode) => {
    if (!episode.restrictionId) return true;

    return viewingRestrictions.value
      ? viewingRestrictions.value[episode.restrictionId] === true
      : false;
  }),
);

const viewingRestrictions = computed(() => state.projects?.viewingRestrictions);

function watchEpisode(episode: IEpisode) {
  if (!userId.value) {
    if (episode.slug === RZR_EPISODE_1_SLUG) {
      dispatch('projects/showRZREpisode1');
      return;
    }

    goToLoginService();
    return;
  }
  dispatch('projects/showEpisode', {
    episode: episode,
  });
}

function goToLoginService() {
  const redirect = router.currentRoute.fullPath;
  dispatch<TPromptToLoginDispatch>({
    type: 'promptToLogin',
    redirectAfterLoginPath: redirect,
  });
}

const ctaImgDims = computed(() => {
  return $vuetify?.breakpoint?.smAndUp ? 110 : 90;
});

return { __sfc: true,props, state, dispatch, router, $vuetify, userId, watchableEpisodes, viewingRestrictions, watchEpisode, goToLoginService, ctaImgDims, ProjectEpisode, ProjectMysteryBoxUpsell }
}

})